<label [ngClass]="wrapperClasses" (click)="onToggle()">

  <!-- ── Track + thumb ────────────────────────────────────────── -->
  <span class="toggle__track">
    <span class="toggle__thumb"></span>
  </span>

  <!-- ── Label ────────────────────────────────────────────────── -->
  @if (label) {
    <span class="toggle__label">{{ label }}</span>
  }

</label>

<!-- Message d'erreur -->
@if (showError) {
  <span class="toggle-error" role="alert">
    {{ errorMessage }}
  </span>
}
